import { WhereClauses } from '@/composables/charts/influx-charts/chart-serialization/WhereClauses'

export type CompiledInfluxQueryObject = {
  path: string
  query: InfluxQuery | InfluxQuery[]
}

export type CompiledInfluxQueryObjectWithSingleQuery = CompiledInfluxQueryObject & {
  query: InfluxQuery
}

export type InfluxQuery = {
  where?: WhereClauses
  time?: {
    start: number
    end: number
  }
  timeResolution?: string
  fill?: number | 'linear' | 'none' | 'previous' | null
  columns?: object | string[] | string
  groupByTags?: string[]
  customPredicates?: string[]
}

export const availableXAggregations = ['mean', 'min', 'max', 'sum', 'count', 'median', 'first', 'last'] as const

export type xAggregations = (typeof availableXAggregations)[number]

export type TagSelector<Tag extends string> = {
  tag: Tag
  useAll: boolean
  specificValues?: string[]
  groupByValues: boolean
  allowEmptyValues: boolean
}
